import { AfterViewInit, ChangeDetectorRef, Component } from "@angular/core";
import { AgFilterComponent } from "@ag-grid-community/angular";
import { IAfterGuiAttachedParams, IDoesFilterPassParams, IFilterParams } from "@ag-grid-community/core";
import { LogService } from "src/app/services/log.service";
import { TranslateService } from "@ngx-translate/core";
import { DropDown } from "../../../../interfaces/drop-down.interface";
import { AppFieldValidators } from 'src/app/utilities/validators';
import { FormBuilder, FormGroup } from "@angular/forms";
import { GridService } from "../../../../services/grid.service";
import { Subscription, take } from "rxjs";
import { LocationService } from "../../../../services/location.service";
import { TapAppStore } from "../../../../state/tap-state";
import { AppState } from "../../../../app.state";
import { Store } from "@ngrx/store";
import * as UserInfoSelectors from '@state/selectors/user-profile.selectors';
import { AppDialogService } from "../../../../services/app-dialog.service";

@Component({
  selector: "geolocation-filter",
  templateUrl: "./geolocation-filter.component.html",
  styleUrls: ["geolocation-filter.component.css"],
})
export class GeolocationFilterComponent implements AgFilterComponent, AfterViewInit {
  params: IFilterParams;
  filterType: string = "";
  filterValues: string[] = [];
  filterTypeId: number = 1;
  _isFilterActive: boolean = false;
  locationList: any[] = null;
  IsLocationListLoaded: boolean = false;
  Validators = AppFieldValidators;

  formGroup: FormGroup = null;
  currentCSOsub: Subscription;
  defaultDistance: number = 10;
  filterValueHasChanged: boolean = false;

  /**
   *
   */
  constructor(
    public translate: TranslateService,
    private logger: LogService,
    private changeDetectorRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private gridService: GridService,
    private locationService: LocationService,
    private store: Store<AppState>,
    private _ads: AppDialogService,


  ) { }
    onNewRowsLoaded?(): void {
        throw new Error("Method not implemented.");
    }
    onAnyFilterChanged?(): void {
        throw new Error("Method not implemented.");
    }
    getFrameworkComponentInstance?() {
        throw new Error("Method not implemented.");
    }
    getModelAsString?(model: any): string {
        throw new Error("Method not implemented.");
    }

  agInit(params: IFilterParams): void {
    this.logger.log("Geolocation Filter Params are:", params);
    this.params = params;
  }

  public ngAfterViewInit(): void {
    this.buildGroup();

    //When the CSO changes are detected, reset the geolocation filter values
    this.currentCSOsub = this.store
      .select(UserInfoSelectors.selectCsoId)
      .subscribe((orgId) => {
        if (orgId < 1) return;

        // CSO has changed
        this.locationId = 0;
        this.distance = this.defaultDistance;
        this.centerLat = 0;
        this.centerLon = 0;
        this.locationList = [];
        this.loadLocationList();

        this.filterType = 'set';
        this.filterTypeId = 1;
        this.filterValues = [];
        this._isFilterActive = true;

      });
  }

  buildGroup() {
    this.formGroup = this.formBuilder.group({
      locationId: [0],
      distance: [this.defaultDistance],
      centerLat: [0],
      centerLon: [0]
    });
  }

  isFilterActive(): boolean {
    return this._isFilterActive;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    return true;
  }

  getModel() {
    return this._isFilterActive
      ? {
        filterType: this.filterType,
        values: this.filterValues,
      }
      : null;
  }

  setModel(model: any) {
    if (!model) {
      return;
    }

    this.locationId = parseInt(model.values[0]);
    this.distance = parseFloat(model.values[1]);
    this.centerLat = parseFloat(model.values[2]);
    this.centerLon = parseFloat(model.values[3]);

    this.filterType = model.filterType;
    this.filterTypeId = this.locationId == 0 ? 2 : 1;
    this.filterValues = model.values;
    this._isFilterActive = true;
  }

  updateFilter() {
    this.filterValues = [this.locationId?.toString(), this.distance.toString(), this.centerLat.toString(), this.centerLon.toString()];
    this.params.filterChangedCallback();
  }

  applyFilterClicked() {
    this.formGroup.updateValueAndValidity();

    // reject if lat/lon not valid
    if (this.filterTypeId == 2 && !this.isLatLonValid(this.centerLat, this.centerLon)) {
      this.locationService.snackBar.open(`${this.translate.instant('Header.Geolocation.InvalidLatLon')}: (${this.centerLat}, ${this.centerLon})`, null, { duration: 4000, panelClass: ['snackbar-failure'], });
      return;
    }

    if (this.formGroup.invalid) return;
    this.applyFilter();
  }

  applyFilter() {
    // for location based filter
    if (this.filterTypeId == 1 && this.locationId && this.locationId > 0) {
      // get the lat/lon for the selected location and add to value list
      this.locationService.getLocationLatLon(this.locationId).subscribe(
        (data: any) => {
          if (data.latitude == 0 && data.longitude == 0) {
            this._ads.showErrorMessage(this.translate.instant('LocationForm.MissingLatLng'));
            return;
          }
          this.centerLat = data.latitude;
          this.centerLon = data.longitude;
          this._isFilterActive = true;
          this.filterValueHasChanged = false;
          this.updateFilter();
        },
        (error) =>
          this.logger.error(
            'An error occured - ' + error.status + ' - ' + error.statusText,
          ),
      );
      return;
    }

    // for lat/lon based filter
    if (this.filterTypeId == 2) {
      this.locationId = 0;
      this._isFilterActive = true;
      this.updateFilter();
      return
    }
  }

  clearFilter() {
    this.filterType = "";
    this.locationId = null;
    this.distance = 10;
    this.centerLat = 0;
    this.centerLon = 0;
    this._isFilterActive = false;
    this.updateFilter();
  }

  disableClear(): boolean {
    return !this._isFilterActive;
  }

  disableApply(): boolean {
    if (this.filterValueHasChanged == false)
      return true;

    if (this.filterTypeId == 1) {
      return this.distance < 1 || (this.locationId ?? 0) < 1;
    }

    if (this.filterTypeId == 2) {
      return this.distance < 1 || !this.isValidLatLon();
    }
  }

  isValidLatLon(): boolean {
    return this.centerLat != null && this.centerLon != null && this.centerLat != 0 && this.centerLon != 0;
  }
 get locationFormControl() {
    return this.formGroup?.get('locationId');
  }
  get locationId() {
    return this.locationFormControl?.value;
  }
  set locationId(value: any) {
    this.locationFormControl?.setValue(value);
    this.filterValueHasChanged = true;
  }

  get distanceFormControl() {
    return this.formGroup?.get('distance');
  }
  get distance() {
    return this.distanceFormControl?.value;
  }
  set distance(value: any) {
    this.distanceFormControl?.setValue(value);
    this.filterValueHasChanged = true;
  }

  get centerLatFormControl() {
    return this.formGroup?.get('centerLat');
  }
  get centerLat() {
    return this.centerLatFormControl?.value;
  }
  set centerLat(value: any) {
    this.centerLatFormControl?.setValue(value);
    this.filterValueHasChanged = true;
  }

  get centerLonFormControl() {
    return this.formGroup?.get('centerLon');
  }
  get centerLon() {
    return this.centerLonFormControl?.value;
  }
  set centerLon(value: any) {
    this.centerLonFormControl?.setValue(value);
    this.filterValueHasChanged = true;
  }

  loadLocationList() {
    this.locationList = [];
    this.IsLocationListLoaded = false;
    var locations = this.gridService.getGeolocationList()
      .pipe(take(1))
      .subscribe((data) => {
        this.locationList = data;
        this.IsLocationListLoaded = true;
        this.scrollToBottom();
      });
  }

  filterTypeChanged(typeId: number) {
    this.filterTypeId = typeId;
    this.filterValueHasChanged = true;
    this.scrollToBottom();
  }

  scrollToBottom() {
    var element = document.getElementById("geolocationBottom");
    if (!element) return;
    element.scrollIntoView({
      block: "start",
      inline: "nearest"
    });
  }

  isLatLonValid(lat: number, lng: number): boolean {
    if (!lat || isNaN(lat) || !lng || isNaN(lng))
      return false;
    if (lat <= -90 || lat >= 90 || lng <= -180 || lng >= 180)
      return false
    return true;
  }

  onLocationIdChange($event: any) {
    this.locationId = $event.value;
  }

}
